import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { List } from 'immutable';
import { addMultiNodalTable } from '../store/deal.store';
import MultiNodalRouteTable from './MultiNodalRouteTable';
import { createSelector } from 'reselect';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';

export const TRANSSHIPMENT_EXPENSE = 'Transshipment';

class MultiNodalTab extends React.PureComponent {
  handleAddRoute = () => {
    this.props.addMultiNodalTable(this.props.currencyRates);
  }
  render() {
    const tables = [];
    for (let i = 0; i < this.props.dataSize; i++) {
      tables.push(<div style={{ paddingBottom: '15px' }}><MultiNodalRouteTable
        key={i}
        startAtomsLinking={this.props.startAtomsLinking}
        productIdx={this.props.productIdx}
        routeIdx={i}
        transshipmentExpense={this.props.transshipmentExpense}
        viewHeader={i == 0}
      /></div>);
    }
    return (<Row className={'multinodal-tab payments'}>
      {!this.props.viewMode && <Col xs={12}>
        <Button
          bsStyle="primary"
          disabled={this.props.disabled}
          onClick={this.handleAddRoute}
        >
          New route
        </Button>
      </Col>}
      <Col xs={12}>
        {tables}
      </Col>
    </Row>);
  }
}
const getTableList = (state, props) => state.getIn(['data', 'deals', 'deal', 'products',
  props.productIdx, 'multiNodalRoutes'], new List());
const getTableListSize = createSelector([getTableList], l => l.size);

const getExpensesTypes = state =>
  state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List());
const getTransshipmentExpense = createSelector([getExpensesTypes],
  expenses => expenses.find(e => e.get('name') == TRANSSHIPMENT_EXPENSE));
export default connect((state, props) => ({
  dataSize: getTableListSize(state, props),
  transshipmentExpense: getTransshipmentExpense(state),
  currencyRates: state.getIn(['data', 'currencies', 'USD', 'rates'], [])
    .map(r => r.set('value', r.get('currency'))),
}), (dispatch, props) => ({
  addMultiNodalTable(rates) {
    addMultiNodalTable(dispatch, props.productIdx, rates);
  },
}))(MultiNodalTab);
